<template>
  <div v-loading="loading" class="portfolioexcelview mt-1">
    <div class="portfolio-excel-top-container">
      <div v-loading="!tableLoaded" class="top-container-list">
        <div class="list--matching">
          <div class="dis-flex mb-1">
            <div>{{ $t("matching-cols") }}: </div>
            <div class="simulate-input-box ml-1">{{ matchedcolumns.length }} / {{ inputMatchDATA.length }}</div></div>
          <div class="dis-flex">
            <div>{{ $t("unmatching-cols") }}: </div>
            <div class="simulate-input-box ml-1">{{ mismatchcolumns }} / {{ inputMatchDATA.length }}</div></div>
        </div>
        <div class="list--recommended mt-2">
          <div class="brains-strong--600 recommended-strong-title">{{ $t("recommended-categories") }}:</div>
          <div class="dis-flex mb-1">
            <div>{{ $t("asset-features") }}: </div>
            <div class="simulate-input-box ml-1 mr-1">{{ matchedColumnsAssetFeatures }} <span>{{ $t("matching-cols-lower") }}</span><span v-if="matchedColumnsAssetFeatures < 1" class="recommended-exclamation" :title="$t('recommendation-number-elements-portfolio')">!</span></div>
          </div>
          <div class="dis-flex mb-1">
            <div>{{ $t("maps.surface") }}: </div>
            <div class="simulate-input-box ml-1 mr-1">{{ matchedColumnsSurfaces }} <span>{{ $t("matching-cols-lower") }}</span><span v-if="matchedColumnsSurfaces < 1" class="recommended-exclamation" :title="$t('recommendation-number-elements-portfolio')">!</span></div>
          </div>
          <div class="dis-flex mb-1">
            <div>{{ $t("value") }}: </div>
            <div class="simulate-input-box ml-1 mr-1">{{ matchedColumnsValues }} <span>{{ $t("matching-cols-lower") }}</span><span v-if="matchedColumnsValues < 2" class="recommended-exclamation" :title="$t('recommendation-number-elements-portfolio')">!</span></div>
          </div>
          <div class="dis-flex">
            <div>{{ $t("localization") }}: </div>
            <div class="simulate-input-box ml-1 mr-1">{{ matchedColumnsLocalizations }} <span>{{ $t("matching-cols-lower") }}</span><span v-if="matchedColumnsLocalizations < 1" class="recommended-exclamation" :title="$t('recommendation-number-elements-portfolio')">!</span></div>
          </div>
        </div>
      </div>
      <div class="top-container-instructions instructions">
        <div class="instructions--title">
          {{ $t("please-match-headers-with-info") }}
        </div>
        <div class="instructions--title" v-html="$t('recommendation-text-instructions-strats')" />
        <p class="instructions--subtitle">
          {{ $t("for-location-and-data-enrichment") }}
        </p>
        <p>{{ $t("alternatively") }}:</p>
        <ul>
          <li>{{ $t("lat-and-long") }}</li>
          <li>{{ $t("cad-ref-only-spain") }}</li>
          <li>{{ $t("country-province-munic-address") }}</li>
        </ul>
      </div>
      <div class="pf-btn-control">
        <div class="upd-portfolio-rules-container">
          <div class="upd-portfolio-rules-title">{{ $t('portfoliosSelector.variables-type') }}</div>
          <div class="upd-portfolio-rules-table" role="presentation" aria-describedby="updportfolio">
            <table role="presentation">
              <tr>
                <td>ID</td>
                <td>String, Varchar, Text</td>
              </tr>
              <tr>
                <td>Location GPS</td>
                <td>Float</td>
              </tr>
              <tr>
                <td>Location Address</td>
                <td>String, Varchar, Text</td>
              </tr>
              <tr>
                <td>Asset Features</td>
                <td>String, Varchar, Text</td>
              </tr>
              <tr>
                <td>Surface</td>
                <td>Float</td>
              </tr>
              <tr>
                <td>Values</td>
                <td>Float</td>
              </tr>
              <tr>
                <td>Dates</td>
                <td>Dates</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="enablebuttons" class="list--btns-container mt-1">
          <button class="brains-type5-btn mr-1" @click="clearmatches()">{{ $t("reset-matches") }}</button>
          <button class="brains-type1-btn mr-1" @click="continuevalidation()">{{ $t("validate") }}</button>
          <!-- <button class="brains-type6-btn" @click="savematches()">{{ $t("save-matches") }}</button> -->
        </div>
      </div>
    </div>

    <div class="pf-upload-excelview-container mt-2">
      <table class="pf-upload-excelview-table" role="presentation" aria-describedby="uploadexcelview">
        <!-- Primera Fila con columnas alfabetizadas -->
        <tr>
          <td class="exceltable-numericleft" />
          <td v-for="(item, index) in headersExcel[0]" :key="index" class="exceltable-alphabetic">
            <div>{{ getAlphabeticLetter(index) }}</div>
          </td>
        </tr>

        <tr>
          <td class="exceltable-numericleft">1</td>
          <td v-for="(item, index) in inputMatchDATA" :key="index" class="exceltable-selector exceltable-first-selector">
            <portfolioexcelDropdown
              :sel-section="item.section"
              :sel-title="item.title"
              :options="headersections"
              :matchedcols="matchedcolumns"
              :class="{'exceltable-selector--matched' : item.section !== ''}"
              @input="setNewMatchedColumn(index, ...arguments)"
            />
          </td>
        </tr>
        <!-- Segunda Fila con desplegable padre -->
        <!-- <tr>
          <td class="exceltable-numericleft">1</td>
          <td v-for="(item, index) in inputMatchDATA" :key="index" class="exceltable-selector exceltable-first-selector">
            <autocompleteSelect
              v-model="item.section"
              :options="cleanHeadersections"
              :placeholder="'Select section header'"
              :class="{'exceltable-selector--matched' : item.section !== ''}"
              @input="setMatchedColumnParent(index, ...arguments)"
            />
          </td>
        </tr> -->

        <!-- Tercera Fila con desplegable hijo -->
        <!-- <tr>
          <td class="exceltable-numericleft">2</td>
          <td v-for="(item, index) in inputMatchDATA" :key="index" class="exceltable-selector">
            <autocompleteSelect
              v-model="item.title"
              :options="selectOptionsMatch[index]"
              :placeholder="'Select variable'"
              :class="{'exceltable-selector--disabled' : selectOptionsMatch[index].length === 0, 'exceltable-selector--matched' : item.title !== ''}"
              :matchedcols="matchedcolumns"
              @input="setMatchedColumn(index, ...arguments)"
            >
              <div class="pf-upload-secondrow-tooltip">
                <div class="pf-upd-tooltip-content">
                  {{ $t('pf-upload-tooltip') }}
                </div>
              </div>
            </autocompleteSelect>
          </td>
        </tr> -->

        <!-- Resto de la tabla - Filas con datos de Ejemplo -->
        <tr v-for="(row, index) in dataExcel" :key="index">
          <td class="exceltable-numericleft"><div>{{ index + 3 }}</div></td>
          <td v-for="(item, index2) in row" :key="index2" class="exceltable-data-readonly">
            <div>{{ item }}</div>
          </td>
        </tr>
      </table>
    </div>
    <el-dialog title="BrainsRe" :visible.sync="showerrordialog" width="60%">
      <h3>{{ $t("portfoliosSelector.ValidationError") }}</h3>
      <div>
        <span class="propname">{{ $t("portfoliosSelector.row") }}:</span><span class="propvalue">{{ valerror.row }}</span>
      </div>
      <div>
        <span class="propname">{{ $t("portfoliosSelector.columnclient") }}:</span><span class="propvalue">{{ valerror.column.clientTitle }}</span>
      </div>
      <div>
        <span class="propname">{{ $t("portfoliosSelector.columnbrains") }}:</span><span class="propvalue">{{ valerror.column.brainsSection }} / {{ valerror.column.brainsTitle }} ({{ valerror.column.brainsId }})</span>
      </div>
      <div>
        <span class="propname">{{ $t("portfoliosSelector.expectedtype") }}:</span><span class="propvalue">{{ valerror.expectedval }}</span>
      </div>
      <div>
        <span class="propname">{{ $t("portfoliosSelector.excelvalue") }}:</span><span class="propvalue">{{ valerror.value }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="brains-type1-btn mt-2" @click="showerrordialog = false">{{ $t("portfoliosSelector.Matchcolumns") }}</el-button>
        <el-button type="brains-type1-btn mt-2" @click="gotostep1()">{{ $t("portfoliosSelector.uploadanotherexcel") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
// import { getportfoliovalidation, findportfoliotypos, setportfoliovalidation } from '@/api/portfoliouser'

import portfolioexcelDropdown from '@/components/portfolioexcelDropdown.vue'

export default {
  name: 'Portfolioexcelc',
  components: { portfolioexcelDropdown },
  props: {
    portfolioname: {
      required: true,
      type: Number
    }
  },
  data() {
    this.headersections = ['0']
    return {
      alphabetString: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      headersExcel: [],
      dataExcel: [],
      inputMatchDATA: [],
      selectOptionsMatch: [],
      loading: false,
      tableLoaded: false,
      enablebuttons: true,
      matchedcolumns: [],
      showerrordialog: false,
      valerror: {
        row: 0,
        column: {
          clientTitle: '',
          brainsTitle: '',
          brainsId: '',
          brainsSection: ''
        },
        value: null,
        expectedval: null
      }
    }
  },
  computed: {
    cleanHeadersections: function() {
      var arr = []
      this.headersections.map(function(item) {
        arr.push(item.header.Name)
      })
      return arr
    },
    mismatchcolumns: function(newOne, oldOne) {
      const vm = this
      if (vm.headersections.length === 0) {
        return 'no headers'
      } else {
        return vm.inputMatchDATA.length - vm.matchedcolumns.length
      }
    },
    // La cantidad de elementos seleccionados actualmente mirando por su section en Brains tener en cuenta que si se cambia el nombre de
    // una sección, esto dejaria de funcionar
    matchedColumnsAssetFeatures() {
      return this.matchedcolumns.filter((item) => {
        return item.brainsSection.includes('Asset Features')
      }).length
    },
    matchedColumnsSurfaces() {
      return this.matchedcolumns.filter((item) => {
        return item.brainsSection.includes('Surface')
      }).length
    },
    matchedColumnsValues() {
      return this.matchedcolumns.filter((item) => {
        return item.brainsSection.includes('Values')
      }).length
    },
    matchedColumnsLocalizations() {
      return this.matchedcolumns.filter((item) => {
        return item.brainsSection.includes('Location Address')
      }).length + this.matchedcolumns.filter((item) => {
        return item.brainsSection.includes('Location Gps')
      }).length
    }
  },
  mounted() {
    this.loaduserdata()
  },
  activated() {
    this.loaduserdata()
  },
  methods: {
    setMatchedColumnParent(index, val) {
      var currentMatch = _.filter(this.matchedcolumns, function(item) { return item.index === index })
      if (currentMatch.length > 0) {
        this.matchedcolumns = _.reject(this.matchedcolumns, function(item) { return item.index === index })
      }

      var posVal = _.filter(this.headersections, function(item) { return item.header.Name === val })
      this.inputMatchDATA[index].title = ''
      var arr = []
      console.log(this.inputMatchDATA[index].section)
      if (posVal.length > 0) { posVal[0].columns.map(function(item) { arr.push(item.title) }) }
      this.selectOptionsMatch[index] = arr
    },
    setMatchedColumn(index, val) {
      var brainsSection = this.inputMatchDATA[index].section
      console.log(brainsSection)
      var brainsID = _.filter(this.headersections, function(item) { return item.header.Name === brainsSection })[0].columns
      brainsID = _.filter(brainsID, function(item) { return item.title === val })

      if (brainsID.length === 0) {
        this.matchedcolumns = _.reject(this.matchedcolumns, function(item) { return item.index === index })
        this.inputMatchDATA[index].title = ''
        return
      }

      var newMatch = {
        clientTitle: this.dataExcel[0][index],
        brainsTitle: val,
        brainsSection: brainsSection,
        brainsId: brainsID[0].id,
        index: index
      }

      var currentMatch = _.filter(this.matchedcolumns, function(item) { return item.index === index })
      if (currentMatch.length > 0) {
        currentMatch[0] = newMatch
      } else {
        this.matchedcolumns.push(newMatch)
      }
    },
    setNewMatchedColumn(index, val) {
      if (val.parent === null) {
        this.inputMatchDATA[index].section = ''
        this.inputMatchDATA[index].title = ''
        this.matchedcolumns = this.matchedcolumns.filter(f => f.index !== index)
        return
      }

      var newMatch = {
        clientTitle: this.dataExcel[0][index],
        brainsTitle: val.child,
        brainsSection: val.parent,
        brainsId: val.childID,
        index: index
      }

      this.inputMatchDATA[index].section = val.parent
      this.inputMatchDATA[index].title = val.child

      var currentMatch = _.filter(this.matchedcolumns, function(item) { return item.index === index })
      if (currentMatch.length > 0) {
        currentMatch[0] = newMatch
      } else {
        this.matchedcolumns.push(newMatch)
      }
    },
    getAlphabeticLetter(index) {
      var alphArr = this.alphabetString.split('')
      var letter = ''
      if (index >= alphArr.length) {
        var letterIndex = Math.trunc(index / alphArr.length)
        letter = alphArr[letterIndex - 1]
        letter += alphArr[(index - (alphArr.length * letterIndex))]
      } else {
        letter = alphArr[index]
      }
      return letter
    },
    activatebuttons(val) {
      this.enablebuttons = val
    },
    continuevalidation() {
      const vm = this
      vm.loading = true
      const columnsmatchs = {
        id: vm.portfolioname,
        columns: vm.matchedcolumns,
        typos: null
      }
      if (vm.matchedcolumns.some(s => s.brainsId === 'Asset_Features_03')) {
        vm.$store.dispatch('portfolio/findportfoliotypos', columnsmatchs)
          .then((response) => {
            console.log('typos done')
            vm.loading = false
          })
      } else {
        vm.$confirm(vm.$t('portfoliosSelector.warningTypoMatch'), 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          vm.$store.dispatch('portfolio/setportfoliovalidation', columnsmatchs)
            .then((response) => {
              console.log(response)
              vm.loading = false
            })
            .catch(() => {
              vm.activatebuttons(true)
              vm.$message({
                showClose: true,
                message: this.$t('portfoliosSelector.errorgettingexcel'),
                type: 'error'
              })
              vm.loading = false
            })
        }).catch(() => {
          vm.loading = false
        })
      }
    },
    setviewdata(rows, headersections, prematch) {
      const vm = this
      console.log('ye buddy itwewe')
      console.log(rows)
      console.log(headersections)
      console.log(prematch)
      vm.headersections = headersections
      vm.inputMatchDATA = []

      // 1. Iterar todas las columnas del excel
      for (var i = 0; i < rows[0].length; i++) {
        // 2. En caso de encontrar match, rellenar desplegable padre + hijo (el match se hace en back)
        var dataPrematch = _.filter(prematch, function(item) { return item.index === i })
        if (dataPrematch.length > 0 && headersections.some(s => s.header.Name === dataPrematch[0].headervalue)) {
          dataPrematch = dataPrematch[0]

          // Paso para asegurar que la variable existe (en caso de que se cambie o se deje de utilizar una variable previamente matcheada)
          // Primero se confima que existe la categoría y luego la variable en sí
          var brainsID = _.filter(this.headersections, function(item) { return item.header.Name === dataPrematch.headervalue })
          if (brainsID.length > 0) {
            brainsID = brainsID[0].columns
            brainsID = _.filter(brainsID, function(item) { return item.title === dataPrematch.value })
            var newMatch = {}

            if (brainsID.length > 0) {
              // Todo OK -> se inserta en array de matcheos + se rellena desplegable
              newMatch = {
                clientTitle: rows[2][i],
                brainsTitle: dataPrematch.value,
                brainsSection: dataPrematch.headervalue,
                brainsId: brainsID[0].id,
                index: i
              }
              vm.matchedcolumns.push(newMatch)

              vm.inputMatchDATA.push({
                index: i,
                section: dataPrematch.headervalue,
                title: dataPrematch.value
              })

              var posVal = _.filter(vm.headersections, function(item) { return item.header.Name === dataPrematch.headervalue })
              var arr = []
              if (posVal.length > 0) { posVal[0].columns.map(function(item) { arr.push(item.title) }) }
              vm.selectOptionsMatch.push(arr)
            } else {
              newMatch = {
                clientTitle: rows[2][i],
                brainsTitle: null,
                brainsSection: dataPrematch.headervalue,
                brainsId: null,
                index: i
              }
              vm.matchedcolumns.push(newMatch)

              vm.inputMatchDATA.push({
                index: i,
                section: dataPrematch.headervalue,
                title: ''
              })
            }
          } else {
            insertCleanMatch(i)
          }
        } else {
          insertCleanMatch(i)
        }
      }
      vm.activatebuttons(true)

      vm.headersExcel = []
      vm.headersExcel.push(rows[0])
      vm.headersExcel.push(rows[1])
      vm.dataExcel = rows.splice(2, rows.length)

      vm.tableLoaded = true

      function insertCleanMatch(i) {
        vm.inputMatchDATA.push({
          index: i,
          section: '',
          title: ''
        })
        vm.selectOptionsMatch.push([])
      }
    },
    clearmatches() {
      const vm = this
      vm.matchedcolumns = []
      for (var i = 0; i < vm.inputMatchDATA.length; i++) {
        vm.inputMatchDATA[i].section = ''
        vm.inputMatchDATA[i].title = ''
        vm.selectOptionsMatch[i] = []
      }
    },
    showvalidationerror(data) {
      // debugger
      const vm = this
      vm.valerror = data
      vm.showerrordialog = true
    },
    gotostep1() {
      const vm = this
      // revisar esto si se cambia la structura ...
      const data = JSON.stringify({
        portfoliojob: 1,
        step: 1
      })
      vm.$parent.$parent.$parent.handleportfoliostep(data)
    },
    loaduserdata() {
      const vm = this
      vm.$store.dispatch('portfolio/getportfoliovalidation', { Id: vm.portfolioname })
        .then((response) => {
          // vm.data = response.rows
          vm.loading = false
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.errorgettingexcel'),
            type: 'error'
          })
          vm.loading = false
        })
    },
    savematches() {
      // debugger
    }
  }
}
</script>
<style lang="scss" scoped>
.upd-portfolio-rules-container {
  background-color: #1e3cff9a;
  height: 100%;
  display: flex;
  flex-direction: column;

  .upd-portfolio-rules-title {
    font-size: 15px;
    font-family: 'Montserrat-SemiBold',sans-serif;
    text-align: center;
    border-bottom: 1px solid white;
    width: 100%;
    padding: 8px;
  }

  .upd-portfolio-rules-table {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    table {
      width: 100%;
      font-size: 14px;
      overflow: scroll;

      & td:nth-child(1) {
        width: 50%;
        font-family: 'Montserrat-SemiBold',sans-serif;
        text-align: right;
        padding: 2px 5px 2px 0;
      }

      & td:nth-child(2) {
        font-family: 'Montserrat-Regular',sans-serif;
        text-align: left;
        padding: 2px 0 2px 5px;
      }
    }
  }
}

.pf-upload-excelview-container {
  height: 100%;
  overflow-y: visible;
  overflow-x: scroll;
  padding: 0;
  z-index: 10;

  &::-webkit-scrollbar {
   width: 13px;
   height: 13px;
   z-index: 10;
  }

  &::-webkit-scrollbar-thumb {
   background-color: lightgrey;
   border-radius: 15px;
   /*
   &:horizontal {
     border-bottom: 1px solid lightgrey;
   }
   */
   &:hover {
    background: lightgrey;
   }
  }

  &::-webkit-scrollbar-track {
    background: rgb(247, 247, 247);
    width: 16px;
    height: 16px;
    /*
    &:horizontal {
     border-bottom: 1px solid rgb(204, 204, 204);
   }
   */
  }

  &::-webkit-scrollbar-button:single-button {
    background-color: #bbbbbb;
    display: block;
    border-style: solid;
    height: 16px;
    width: 16px;
    border: 0;
  }

  &::-webkit-scrollbar-button:horizontal:end:increment {
    width: 16px;
    height: 16px;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 10px solid rgb(109, 109, 109);
    border-right: 0;

    &:hover {
      border-left-color: grey;
    }
  }

  &::-webkit-scrollbar-button:horizontal:start:decrement {
    width: 14px;
    height: 14px;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 0;
    border-right: 10px solid rgb(109, 109, 109);

    &:hover {
      border-left-color: grey;
    }
  }

  .pf-upload-excelview-table {
    font-family: 'Montserrat-Light',sans-serif;
    font-size: 13px;

    td {
      height: 22px;
      vertical-align: middle;
      border: 1px solid #ccc;
      min-width: 180px;
      width: 1%;
      white-space: nowrap;
      padding: 4px 6px;
      cursor: unset;
    }

    .exceltable-numericleft {
      position: sticky;
      position: -webkit-sticky;
      min-width: 50px;
      max-width: 50px;
      width: 50px;
      left: 0;
    }

    .exceltable-alphabetic, .exceltable-numericleft {
      background-color: #f0f0f0;
      color: #222;
      text-align: center;
      font-family: 'Montserrat-SemiBold',sans-serif;
      user-select: none;
      pointer-events: none;
      z-index: 1300;
    }

    .exceltable-data-readonly {
      pointer-events: none;
      user-select: none;
    }
  }
}

.simulate-input-box {
  box-sizing: border-box;
  border: 1px solid lightgrey;
  padding: 0 10px;
  pointer-events: none;
}

.propname {
  font-weight: bold;
}
.propvalue {
  margin-left: 15px;
}
.pf-btn-control {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.list--btns-container {
  display: flex;
  margin-left: auto;
  margin-right: 0;
}

.portfolio-excel-top-container {
  font-size: 13px;
  font-family: 'Montserrat-Light',sans-serif;
  display: grid;
  justify-content: flex-start;
  grid-template-columns: 1fr 1fr 1fr;

  .top-container-list {
    padding-left: 50px;
    .list {
      &--matching {
        line-height: 25px;
      }

      &--recommended {
        line-height: 25px;

        .recommended-strong-title {
          font-family: "Montserrat-ExtraBold",sans-serif;
        }

        div .recommended-exclamation {
          color: red;
          font-family: "Montserrat-SemiBold",sans-serif;
          // margin-left: 5px;
          font-size: 20px;
          width: 20px;
          display: inline-flex;
          justify-content: center;
        }

        div span {
          color: rgb(194, 194, 194);
        }
      }
    }
  }

  .top-container-instructions {
    .instructions {
      &--title {
        // text-align: center;
        // padding: 0 15px 0 15px;
        margin-bottom: 15px;
        line-height: 25px;
      }
    }

    div {
      margin-bottom: 8px;
    }

    ul {
      // list-style: ;
      li {
        margin-bottom: 8px;
      }

      li:before {
        content: "- ";
        padding-right: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.pf-upload-secondrow-tooltip {
  position: absolute;
  display: none;
  z-index: 2300;
  width: 200px;
  height: 50px;
  border-radius: 5px;
  background-color: rgb(230, 64, 64);
  box-shadow: 1px 2px 2px 1px rgb(216, 36, 36);
  font-family: 'Montserrat-SemiBold',sans-serif;
  text-align: center;
  font-size: 13px;
  color: white;

  .pf-upd-tooltip-content {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
}

.exceltable-selector {
  padding: 0 !important;
  margin: 0;
  width: 100%;
  height: 22px;

  input {
    outline: none;
    border: none;
    background-color: #1e3cff;
    color: white;

    &::placeholder {
      color: white;
    }
    &:focus::placeholder {
      color: transparent;
    }
  }

  &--disabled {

    input {
      background-color: #ccc;
      color: #aaaaaa;
      pointer-events: none !important;
      user-select: none;
      &::placeholder {
        color: rgb(151, 151, 151) !important;
        user-select: none;
      }
    }

    &:hover .pf-upload-secondrow-tooltip{
      display: block;
    }
  }

  &--matched .pfexcel-dropdown-title {
    background-color: #009999 !important;
  }
}

.exceltable-first-selector {
  background-color: #606266 !important;
  color: #fff !important;
}
</style>
